import React, { useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "./AdminUsers";
import api from "../../../utils/api";


const AddSlider = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [formData, setFormData] = useState({
    title: '',
    status: 'Active',
    type: 'Web',
  });

  const [sliderFile, setSliderFile] = useState(null);
  const [sliderPreviewUrl, setSliderPreviewUrl] = useState('');
  
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState('');

  const [modalFile, setModalFile] = useState(null);
  const [modalPreviewUrl, setModalPreviewUrl] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      // Create a preview URL for the selected image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleLogoFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setLogoFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleModalFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setModalFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setModalPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
  

    e.preventDefault();
    
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('status', formData.status);
    formDataToSend.append('type', formData.type);
    
    if (file) {
      formDataToSend.append('attachment', file);
    }

    try {
      const auth = localStorage.getItem('admin');
      const response = await api.post(
        `/api/webapi/addBanner`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${auth}`,
          }
        }
      );
      
      console.log('Response:', response);
      if (response.data.success) {
        navigate("/admin/slider");
        // Reset form
        setFormData({
          title: '',
          status: 'Active',
          type: 'Web',
        });
        setFile(null);
        setPreviewUrl('');
      }
    } catch (error) {
      console.error('Error adding slider:', error);
      alert('Failed to add slider. Please try again.');
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();

    if (logoFile) {
      formDataToSend.append('attachment2', logoFile);
    }

    try {
      const auth = localStorage.getItem('admin');
      const response = await api.post(
        `/api/webapi/addLogo`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${auth}`,
          }
        }
      );

      if (response.data.success) {
        navigate("/admin/slider");
        setLogoFile(null);
        setLogoPreviewUrl('');
      }
    } catch (error) {
      console.error('Error adding logo:', error);
      alert('Failed to add logo. Please try again.');
    }
  };

  const handleSubmit3 = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();

    if (modalFile) {
      formDataToSend.append('attachment3', modalFile);
    }

    try {
      const auth = localStorage.getItem('admin');
      const response = await api.post(
        `/api/webapi/addModal`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${auth}`,
          }
        }
      );

      if (response.data.success) {
        navigate("/admin/slider");
        setModalFile(null);
        setModalPreviewUrl('');
      }
    } catch (error) {
      console.error('Error adding logo:', error);
      alert('Failed to add modal image. Please try again.');
    }
  };

  return (
    <div className="wrapper">
      <AdminSidebar isSidebarOpen={isSidebarOpen} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

      <div className={`content-wrapper ${isSidebarOpen ? "" : "open-content-wrapper"}`}>
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Add Slider
          </h1>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    <div className="mt-3">
                      <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="d-flex flex-column gap-4">
                          <div>
                            <label htmlFor="title">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              id="title"
                              placeholder="Title"
                              value={formData.title}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div>
                            <label htmlFor="attachment">Attachment</label>
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              name="attachment"
                              id="attachment"
                              onChange={handleFileChange}
                              required
                            />
                            {previewUrl && (
                              <div className="mt-2">
                                <p>Preview:</p>
                                <img
                                  src={previewUrl}
                                  alt="Preview"
                                  style={{ maxWidth: '200px', maxHeight: '200px' }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="custom-select-wrapper">
                            <label htmlFor="status">Status</label>
                            <select
                              id="status"
                              className="form-control custom-select"
                              name="status"
                              onChange={handleChange}
                              value={formData.status}
                            >
                              <option value="Active">Active</option>
                              <option value="Inactive">InActive</option>
                            </select>
                            <i className="fa fa-chevron-down dropdown-icon mt-3"></i>
                          </div>

                          <div className="custom-select-wrapper">
                            <label htmlFor="type">Type</label>
                            <select
                              id="type"
                              className="form-control custom-select"
                              name="type"
                              onChange={handleChange}
                              value={formData.type}
                            >
                              <option value="Web">Web</option>
                              <option value="Phone">Phone</option>
                            </select>
                            <i className="fa fa-chevron-down dropdown-icon mt-3"></i>
                          </div>
                        </div>
                        <button type="submit" className="btn btn-danger red_btn mt-4">
                          Save
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Logo Form */}
        <div className="container-fluid mt-5">
          <h1 className="page-title custom_pagetitle">Add Logo</h1>
          <div className="page-content mt-4 browse">
            <form onSubmit={handleSubmit2} encType="multipart/form-data">
              <div className="d-flex flex-column gap-4">
                <div>
                  <label htmlFor="attachment2">Attachment (Logo)</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    name="attachment2"
                    id="attachment2"
                    onChange={handleLogoFileChange}
                    required
                  />
                  {logoPreviewUrl && (
                    <div className="mt-2">
                      <p>Preview:</p>
                      <img src={logoPreviewUrl} alt="Logo Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                    </div>
                  )}
                </div>
              </div>
              <button type="submit" className="btn btn-danger red_btn mt-4">Save Logo</button>
            </form>
          </div>
        </div>

        {/* Add Modal Form */}
        <div className="container-fluid mt-5">
          <h1 className="page-title custom_pagetitle">Add Modal</h1>
          <div className="page-content mt-4 browse">
            <form onSubmit={handleSubmit3} encType="multipart/form-data">
              <div className="d-flex flex-column gap-4">
                <div>
                  <label htmlFor="attachment3">Attachment (Modal)</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    name="attachment3"
                    id="attachment3"
                    onChange={handleModalFileChange}
                    required
                  />
                  {modalPreviewUrl && (
                    <div className="mt-2">
                      <p>Preview:</p>
                      <img src={modalPreviewUrl} alt="Logo Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                    </div>
                  )}
                </div>
              </div>
              <button type="submit" className="btn btn-danger red_btn mt-4">Save Modal</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSlider;
